import { createFileRoute } from "@tanstack/react-router";
import Compare from "@/pages/Compare";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/compare/")({
  head: () => routeHead("/uk/compare/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Compare />
  );
}
